import React, { FC, useCallback } from 'react'

import { useTranslation } from 'react-i18next'

import Divider from '@vfuk/core-divider'
import Paragraph from '@vfuk/core-paragraph'
import Image from '@vfuk/core-image'
import { loadResources } from '@vfuk/core-language-packs'

import * as Styled from './styles/PartnerInfo.style'

import { PartnerInfoProps } from './PartnerInfo.types'

import languages, { componentName } from '../../locales'

const PartnerInfo: FC<PartnerInfoProps> = ({ partnerLogo }) => {
  const { t, i18n } = useTranslation(componentName)

  const memoizedResources = useCallback(() => loadResources(i18n, componentName, languages), [i18n, componentName, languages])
  memoizedResources()

  return (
    <Styled.PartnerInfoWrapper>
      <Paragraph inverse noMargin>
        {t('Together with')}
      </Paragraph>
      <Styled.DividerWrapper>
        <Divider orientation='vertical' appearance='secondary' inverse />
      </Styled.DividerWrapper>
      <Styled.PartnerLogo>
        <Image
          sm={{ src: partnerLogo!.image, srcSet: { x1: partnerLogo!.image } }}
          // md={{ src: partnerLogo!.image }}
          // lg={{ src: partnerLogo!.image }}
          // xl={{ src: partnerLogo!.image }}
          alt={partnerLogo!.srText}
        />
      </Styled.PartnerLogo>
    </Styled.PartnerInfoWrapper>
  )
}

export default PartnerInfo
